import type { Decorator } from 'final-form';
import { v4 } from 'uuid';
import { toIsoStringWithTimezone } from '@alfa-bank/site-helpers-transform/date/to-iso-string-with-timezone';
import { TRANBILOG_URL } from '@alfa-bank/site-envconfig';

import { decorateSubmit, useDecorator } from '../utils';
import { RECIPIENT_URL } from '../../config';

import { scenarios } from './scenarios';
import type { IBusinessLogger } from './models';

/** Отправление данных бизнес-логирования */
export const useBusinessLogging = ({
    actions,
    product,
    source,
    recipient = RECIPIENT_URL,
}: IBusinessLogger): Decorator<Record<string, unknown>> =>
    useDecorator(
        decorateSubmit(form => {
            if (!source || !product || !scenarios[product]) return;
            const { valid, values } = form.getState();
            if (!valid) return;
            const data = scenarios[product]({ values, actions });
            if (!data) return;

            const { bannerId, platformId } = actions;

            const log = {
                businessUid: v4(),
                clientData: {
                    bannerId: bannerId ?? undefined,
                    platformId:
                        (typeof platformId === 'function' ? platformId() : platformId) ?? '',
                },
                clientDate: toIsoStringWithTimezone(new Date()),
                recipient,
                status: 'OK',
                data,
                source,
            };
            fetch(TRANBILOG_URL(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                keepalive: true,
                body: JSON.stringify(log),
            });
        })
    );
